import React from 'react'
import Dropdown from './Dropdown'
import { dayFields, monthFields, yearFields } from './DropdownValues'
import {
	secondaryNum,
	secondaryNum1,
	secondaryNum2,
	primaryNum,
	primaryNum1,
	primaryNum2,
	lifeCycle,
	composite
} from './calculation'
import { energies } from './data/lifepaths'
import { cycles, dynamics, lifepaths, readMore } from './data/descriptions'
import Icon from './Icon'

export default class App extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			userDay: 0,
			userMonth: 0,
			userYear: 0,
			contactDay: 0,
			contactMonth: 0,
			contactYear: 0
		}
	}

	handleSelect = e => {
		this.setState({ [e.name]: parseInt(e.newValue, 10) })
	}

	userValidation = () =>
		this.state.userDay > 0 && this.state.userMonth > 0 && this.state.userYear > 0

	contactValidation = () =>
		this.state.contactDay > 0 && this.state.contactMonth > 0 && this.state.contactYear > 0

	render() {
		const { userDay, userMonth, userYear, contactDay, contactMonth, contactYear } = this.state
		const dayOptionsUser = dayFields(userMonth, userYear)
		const dayOptionsContact = dayFields(contactMonth, contactYear)
		const monthOptions = monthFields()
		const yearOptions = yearFields()
		const siteUrl = 'peacefulwarrior.com/life-purpose-calculator'
		const SECONDARYNUM = secondaryNum(userDay, userMonth, userYear)
		const SECONDARYNUM1 = secondaryNum1(userDay, userMonth, userYear)
		const SECONDARYNUM2 = secondaryNum2(userDay, userMonth, userYear)
		const PRIMARYNUM = primaryNum(userDay, userMonth, userYear)
		const PRIMARYNUM1 = primaryNum1(userDay, userMonth, userYear)
		const PRIMARYNUM2 = primaryNum2(userDay, userMonth, userYear)
		const LIFEPATH = SECONDARYNUM > 9 ? SECONDARYNUM + '/' + PRIMARYNUM : SECONDARYNUM
		const LIFECYCLE = lifeCycle({ day: userDay, month: userMonth })
		const RELATIONSHIPDYNAMIC = composite({
			user: { day: userDay, month: userMonth, year: userYear },
			contact: { day: contactDay, month: contactMonth, year: contactYear }
		})
		return (
			<div>
				<center>
					<h1>Life-Purpose Calculator</h1>
				</center>

				<div className='lpa-energies bold'>Discover Your Life Path</div>

				<br />

				<div className='lpa-text header'>
					Enter your date of birth to reveal insights about your life path:
				</div>

				<div className='lpa-dropdown'>
					<Dropdown
						name='userDay'
						onSelectChange={this.handleSelect}
						options={dayOptionsUser}
						value={userDay}
					/>
					<Dropdown
						name='userMonth'
						onSelectChange={this.handleSelect}
						options={monthOptions}
						value={userMonth}
					/>
					<Dropdown
						name='userYear'
						onSelectChange={this.handleSelect}
						options={yearOptions}
						value={userYear}
					/>
				</div>

				{this.userValidation() && (
					<div>
						{/* LIFE PATH TEXT */}
						<div className='lpa-result'>
							<div className='lpa-energies bold'>The {LIFEPATH} Life Path</div>
							<br />

							{PRIMARYNUM > 9 && (
								<div>
									<div className='lpa-energies'>
										{SECONDARYNUM1}: {energies[SECONDARYNUM1].energyName}
									</div>

									<div className='lpa-energies bold'>
										{SECONDARYNUM2}: {energies[SECONDARYNUM2].energyName}
									</div>

									<div className='lpa-line' />

									<div className='lpa-energies bold'>
										{PRIMARYNUM1}: {energies[PRIMARYNUM1].energyName}
									</div>

									<div className='lpa-energies'>
										{PRIMARYNUM2}: {energies[PRIMARYNUM2].energyName}
									</div>
								</div>
							)}
							{SECONDARYNUM > 9 && PRIMARYNUM <= 9 && (
								<div>
									<div className='lpa-energies'>
										{SECONDARYNUM1}: {energies[SECONDARYNUM1].energyName}
									</div>

									<div className='lpa-energies'>
										{SECONDARYNUM2}: {energies[SECONDARYNUM2].energyName}
									</div>

									<div className='lpa-line' />

									<div className='lpa-energies bold'>
										{PRIMARYNUM}: {energies[PRIMARYNUM].energyName}
									</div>
								</div>
							)}
							{SECONDARYNUM <= 9 && (
								<div className='lpa-energies bold'>
									{SECONDARYNUM}: {energies[SECONDARYNUM].energyName}
								</div>
							)}

							<div className='lpa-hiddencalling'>
								All digits have an influence—but the bolded issue is key to your{' '}
								<em>hidden calling</em>.
							</div>

							<br />
							{lifepaths[SECONDARYNUM]}
							<br />
							<br />

							<center style={{ color: '#0056da' }}>{readMore}</center>
						</div>

						{/* LIFE CYCLE TEXT */}
						<div className='lpa-result'>
							<div className='lpa-energies'>
								Your Current Year in the 9-Year Cycle:
								<br />
								<div className='lpa-hiddencalling'>* Until your next birthday.</div>
								<div style={{ height: '20px' }} />
								<span className='lpa-energies bold'>
									{LIFECYCLE}: {energies[LIFECYCLE].energyName}
								</span>
							</div>
							<br />
							{cycles[LIFECYCLE]}
						</div>

						{/* FOOTER */}
						<div className='lpa-copyright'>
							Copyright ©1993, 2018 Dan Millman. All rights reserved.
						</div>
					</div>
				)}

				<br />
				<br />

				{/* COMPOSITE */}
				<div className='lpa-energies bold'>Relationship Dynamics</div>
				<br />
				<div className='lpa-text header'>Enter someone else’s date of birth:</div>
				<div className='lpa-dropdown'>
					<Dropdown
						name='contactDay'
						onSelectChange={this.handleSelect}
						options={dayOptionsContact}
						value={contactDay}
					/>
					<Dropdown
						name='contactMonth'
						onSelectChange={this.handleSelect}
						options={monthOptions}
						value={contactMonth}
					/>
					<Dropdown
						name='contactYear'
						onSelectChange={this.handleSelect}
						options={yearOptions}
						value={contactYear}
					/>
				</div>

				{this.userValidation() && this.contactValidation() && (
					<div>
						{/* RELATIONSHIP DYNAMICS TEXT */}
						<div className='lpa-result'>
							<div className='lpa-energies'>
								Relationship Dynamic:
								<div style={{ height: '10px' }} />
								<span className='lpa-energies bold'>
									{RELATIONSHIPDYNAMIC}: {energies[RELATIONSHIPDYNAMIC].energyName}
								</span>
							</div>
							<br />
							<span className='lpa-energies bold'>Positive Aspects and Issues:</span>
							<br />
							{dynamics[RELATIONSHIPDYNAMIC].positive}
							<br />
							<br />
							<span className='lpa-energies bold'>Negative Aspects and Issues:</span>
							<br />
							{dynamics[RELATIONSHIPDYNAMIC].negative}
						</div>

						{/* FOOTER */}
						<div className='lpa-copyright'>
							Copyright ©1993, 2018 Dan Millman. All rights reserved.
						</div>
					</div>
				)}

				<br />
				<br />
				<br />

				<center>
					<h1>Explore</h1>
				</center>

				{/* RESOURCES */}
				<div className='lpa-flex-horizontal'>
					<a className='lpa-flex-vertical' href='https://LifePurposeApp.com' target='_blank'>
						<div className='lpa-resource lpa' />
						<div className='lpa-energies link'>click here</div>
					</a>
					<a
						className='lpa-flex-vertical'
						href='https://www.peacefulwarrior.com/the-life-you-were-born-to-live/'
						target='_blank'
					>
						<div className='lpa-resource life' />
						<div className='lpa-energies link'>click here</div>
					</a>
					<a
						className='lpa-flex-vertical'
						href='https://www.peacefulwarrior.com/peaceful-heart-warrior-spirit/'
						target='_blank'
					>
						<div className='lpa-resource four' />
						<div className='lpa-energies link'>click here</div>
					</a>
				</div>
				<div className='lpa-footer'>
					For Life Purpose App customer support, please visit:{' '}
					<a href='http://support.lifepurposeapp.com' className='lpa-link' target='_blank'>
						support.LifePurposeApp.com
					</a>
				</div>
				<div className='lpa-social'>
					<div className='lpa-social-container'>
						<a
							className='lpa-social-item'
							href={`https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2F${siteUrl}`}
							target='_blank'
						>
							<Icon name='facebook' size='24' color='facebook' />
						</a>
						<a
							className='lpa-social-item'
							href={`https://twitter.com/intent/tweet?text=Check%20out%20the%20Life%20Purpose%20App,%20by%20Dan%20Millman.&url=http%3A%2F%2F${siteUrl}&hashtags=DanMillman,PeacefulWarrior,LifePurposeApp&via=pwDan&related=pwDan%3ADan%20Millman,lifepurposeapp%3ALife%20Purpose%20App,consciousapps%3AConscious%20Apps`}
							target='_blank'
						>
							<Icon name='twitter' size='24' color='twitter' />
						</a>
						<a
							className='lpa-social-item'
							href={`https://www.linkedin.com/shareArticle?mini=true&url=http%3A//${siteUrl}&title=Life%20Purpose%20App&summary=Dan%20Millman,%20bestselling%20author%20of%20Way%20of%20the%20Peaceful%20Warrior,%20presents%20the%20Life-Purpose%20System,%20which%20has%20helped%20millions%20of%20people%20worldwide%20find%20new%20meaning%20and%20purpose.&source=Life%20Purpose%20App`}
							target='_blank'
						>
							<Icon name='linkedin' size='24' color='linkedin' />
						</a>
						<a
							className='lpa-social-item'
							href={`https://api.addthis.com/oexchange/0.8/forward/email/offer?url=http%3A%2F%2F${siteUrl}%2F&pubid=ra-42fed1e187bae420&title=Life%20Purpose%20App%2C%20by%20Dan%20Millman`}
							target='_blank'
						>
							<Icon name='email-outline' size='24' color='email' />
						</a>
					</div>
				</div>
			</div>
		)
	}
}
